import { render, staticRenderFns } from "./SendBackIcon.vue?vue&type=template&id=d972a6a6&"
import script from "./SendBackIcon.vue?vue&type=script&lang=js&"
export * from "./SendBackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports